// Cross-component tab navigation. AppShell owns the active-tab state but pages
// occasionally need to drive transitions (e.g. ReviewBar switching to Monitor
// after Save+Activate). This context exposes navigateTo without coupling pages
// to AppShell internals.

import { createContext, useContext, type ReactNode } from "react";

export type TabId = "builder" | "strategies" | "monitor" | "channels";

interface NavigationContextValue {
  navigateTo: (tab: TabId) => void;
}

const NavigationContext = createContext<NavigationContextValue | null>(null);

export function NavigationProvider({ navigateTo, children }: { navigateTo: (tab: TabId) => void; children: ReactNode }) {
  return (
    <NavigationContext.Provider value={{ navigateTo }}>{children}</NavigationContext.Provider>
  );
}

/** Safe accessor — returns a no-op navigate when no provider is mounted (tests, storybook). */
export function useNavigation(): NavigationContextValue {
  return useContext(NavigationContext) ?? { navigateTo: () => undefined };
}
